//src/app/features/questionnaires/components/WizardFooter/index.tsx
import { CancelIcon, NextIcon, PreviousIcon } from 'assets/icons';
import { CustomButton } from 'Components/Auth/CustomButton';
import { useNavigate } from 'react-router-dom';
import DesktopSkeleton from './components/DesktopSkeleton';
import useMediaQueries from 'app/hooks/useMediaQueries';
import MobileSkeleton from './components/MobileSkeleton';

export interface IWizardFooterProps {
  nextStep?: string;
  previousStep?: string;
  onNext?: () => void;
  onPrevious?: () => void;
  isLoading?: boolean;
}

export default function WizardFooter({
  nextStep,
  previousStep,
  onNext,
  onPrevious,
  isLoading,
}: IWizardFooterProps) {
  const { md_down: isMobile } = useMediaQueries();
  const navigate = useNavigate();

  const proceedBtn = () => {
    if (!nextStep) return <></>;
    return (
      <div className="w-full h-full" onClick={onNext}>
        <CustomButton suffix={<NextIcon />} loading={isLoading}>
          <div className="text-sm w-full pl-6 flex md-max:m-0">
            <span className="font-semibold">Proceed </span>
            <span className="ml-16 font-normal whitespace-nowrap mr-4 md-max:ml-auto">
              {nextStep}
            </span>
          </div>
        </CustomButton>
      </div>
    );
  };

  const cancelBtn = () => {
    if (!nextStep) return <></>;
    return (
      <div
        className="w-full h-full"
        onClick={() => navigate('/dashboard/questionnaires')}
      >
        <CustomButton
          type="button"
          textColor="black"
          bgColor="white"
          borderColor="gray-100"
          prefix={<CancelIcon />}
        >
          <span className="ml-4 text-sm font-semibold flex mr-auto">
            <span className="font-normal pr-3">Cancel</span>
          </span>
        </CustomButton>
      </div>
    );
  };

  const previousBtn = () => (
    <div
      className="w-full h-full"
      onClick={previousStep ? onPrevious : undefined}
    >
      <CustomButton
        type="button"
        textColor="black"
        bgColor="white"
        borderColor="gray-100"
        prefix={
          <PreviousIcon
            className={previousStep ? 'text-black' : 'text-gray-100'}
          />
        }
      >
        <span className="w-28 ml-4 text-sm font-semibold flex mr-auto">
          <span
            className={`font-normal ${!previousStep ? 'text-gray-100' : ''}`}
          >
            Previous Step
          </span>
        </span>
      </CustomButton>
    </div>
  );

  if (isMobile)
    return (
      <MobileSkeleton
        ProceedBtn={proceedBtn}
        CancelBtn={cancelBtn}
        PreviousBtn={previousBtn}
      />
    );
  else
    return (
      <DesktopSkeleton
        ProceedBtn={proceedBtn}
        CancelBtn={cancelBtn}
        PreviousBtn={previousBtn}
      />
    );
}
